import { render } from "./Header.vue?vue&type=template&id=61867ae6&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=61867ae6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-61867ae6"

export default script